import { Component, DestroyRef, effect, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { LnPagesArmorComponent } from '@components/ln-pages-armor/ln-pages-armor.component';
import { LnArrowBackSvgIconComponent } from '@components/svg-icons/ln-arrow-back-svg-icon/ln-arrow-back-svg-icon.component';
import { MenuActions } from '../../shared/states/menu_actions';
import { LnImageFrameComponent } from '@components/ln-image-frame/ln-image-frame.component';
import { TopicParagraphComponent } from '@components/topic-paragraph/topic-paragraph.component';
import { ActivatedRoute } from '@angular/router';
import { ArtisanService } from '@core/services/artisans/artisan.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ApiResponse } from '@interfaces/api/api.interface';
import { SellerDataInterface } from '@interfaces/artisan/get_seller_data';
import { TranslocoPipe } from '@jsverse/transloco';
import { LanguageService } from '@core/services/language/language.service';
import { LnSpecialProductsComponent } from '@components/ln-special-products/ln-special-products.component';

@Component({
  selector: 'ln-artisan-profile',
  imports: [
    LnPagesArmorComponent,
    LnArrowBackSvgIconComponent,
    LnImageFrameComponent,
    TopicParagraphComponent,
    LnSpecialProductsComponent,
    TranslocoPipe,
  ],
  templateUrl: './artisan-profile.component.html',
  styleUrl: './artisan-profile.component.css',
})
export class ArtisanProfileComponent implements OnInit {
  private readonly TAG = 'ArtisanProfileComponent';
  private menuActions = inject(MenuActions);
  private destroyRef = inject(DestroyRef);
  private routes = inject(ActivatedRoute);
  private artisanID: WritableSignal<string> = signal('');
  private artisanService = inject(ArtisanService);
  protected artisanData: WritableSignal<SellerDataInterface | undefined> = signal(undefined);
  private locale = inject(LanguageService);

  constructor() {
    effect(() => {
      this.locale.currentLanguage();
      this.getArtisanInfo();
    });
  }

  ngOnInit(): void {
    this.getQueryParams();
  }

  getQueryParams(): void {
    this.routes.queryParams.subscribe(params => {
      const sellerID = params['sellerID'];

      if (sellerID) {
        this.artisanID.set(sellerID);
        this.getArtisanInfo();
      }
    });
  }

  private getArtisanInfo(): void {
    this.artisanService
      .getArtisanInfo(this.artisanID())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: ApiResponse<SellerDataInterface>) => {
          if (res.success) {
            this.artisanData.set(res.data);
            //console.log(`${this.TAG} Successfully Artisan Info`);
          }
        },
        error: err => {
          console.log(`${this.TAG} error occurred: ${err}`);
        },
      });
  }

  navigateBack() {
    this.menuActions.navigateBack();
  }
}
